import React from 'react';

import Task from './Task';

function Home() {
    return (
        <>
            <Task />
        </>
    )
};

export default Home;